// import OldWay from "../components/homeComponents/OldWay"
import Intro from "../components/homeComponents/Intro"
import Faq from "../components/homeComponents/Faq"
import Pricing from "../components/homeComponents/Pricing"
import Footer from "../components/homeComponents/Footer"
import FacialRecognitionSolution from "../components/homeComponents/FacialRecognitionSolution"
import IntuitiveApp from "../components/homeComponents/IntuitiveApp"
const Home = ()=>{
    return (
        <>    
            <Intro/>
            {/* <OldWay/> */}
            <FacialRecognitionSolution/>
            {/* <HardwareSolution/> */}
            <IntuitiveApp/>
            <Pricing/>
            <Faq/>
            <Footer/>
        </>
    )
}

export default Home
